import { makeClientSideRequest } from '@lib/api/client/http-client';
import Endpoint from '@lib/api/endpoints';

export default async function acceptTermsOfServiceUpdates() {
  return makeClientSideRequest<void, void>(
    Endpoint.AcceptTermsOfServiceUpdates,
    undefined,
  );
}
